'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var deleteRole = require('./deleteRole.js');
var createRoles = require('./createRoles.js');
var getRoles = require('./getRoles.js');
var grantRoles = require('./grantRoles.js');
var revokeRoles = require('./revokeRoles.js');
var getRole = require('./getRole.js');
var getRolesByRoleNameList = require('./getRolesByRoleNameList.js');



exports.deleteRole = deleteRole.deleteRole;
exports.createRoles = createRoles.createRoles;
exports.getRoles = getRoles.getRoles;
exports.grantRoles = grantRoles.grantRoles;
exports.revokeRoles = revokeRoles.revokeRoles;
exports.getRole = getRole.getRole;
exports.getRolesByRoleNameList = getRolesByRoleNameList.getRolesByRoleNameList;
